<template>
  <SvgSprite />
  <div class="as-matches" ref="scrollComponent">
    <div
      v-for="index in 3"
      :key="index"
      :class="`as-competition-wrapper as-competition-wrapper-${siteName}`"
    >
      <div class="as-league_title">
        <div class="as-match_competition">
          <SkeletonLoader width="30px" height="30px" mode="circle" :line="1" />
          <SkeletonLoader width="130px" height="20px" :line="1" />
        </div>
        <div class="as-match__teams as-d-none as-d-lg-flex">
          <div class="as-match__team as-match__team--home">
            <SkeletonLoader width="120px" height="20px" :line="1" />
          </div>
          <div class="as-scoreboard">
            <SkeletonLoader width="50px" height="20px" :line="1" />
          </div>
          <div class="as-match__team as-match__team--away">
            <SkeletonLoader width="120px" height="20px" :line="1" />
          </div>
        </div>
        <div class="as-match__ht as-d-none as-d-lg-flex">
          <SkeletonLoader width="50px" height="20px" :line="1" />
        </div>
        <div class="as-match__corner as-d-none as-d-lg-flex">
          <SkeletonLoader width="50px" height="20px" :line="1" />
        </div>
        <div class="as-match__yellow-goal as-d-none as-d-lg-flex">
          <SkeletonLoader width="50px" height="20px" :line="1" />
        </div>
      </div>

      <div
        v-for="index in 2"
        :key="index"
        :data-id="index"
        class="as-match__item"
      >
        <div class="as-match__item--wrap">
          <div class="as-match__sm">
            <div class="as-match__label">
              <SkeletonLoader width="100px" height="20px" :line="1" />
              <SkeletonLoader width="100px" height="20px" :line="1" />
            </div>
            <div class="as-match__label as-d-flex as-d-lg-none">
              <SkeletonLoader width="50px" height="20px" :line="1" />
              <SkeletonLoader width="50px" height="20px" :line="1" />
            </div>
          </div>
          <div class="as-match__scores as-match__teams">
            <div class="as-match__team as-match__team--home">
              <SkeletonLoader width="40px" height="40px" mode="circle" :line="1" />
              <div class="as-match__team--name as-match__team-home-name">
                <SkeletonLoader width="120px" height="20px" :line="1" />
              </div>
            </div>
            <div class="as-scoreboard">
              <SkeletonLoader width="50px" height="20px" :line="1" />
            </div>
            <div class="as-match__team as-match__team--away">
              <SkeletonLoader width="40px" height="40px" mode="circle" :line="1" />
              <div class="as-match__team--name as-match__team-away-name">
                <SkeletonLoader width="120px" height="20px" :line="1" />
              </div>
            </div>
          </div>
          <div class="as-match__ht as-d-none as-d-lg-flex">
            <SkeletonLoader width="50px" height="20px" :line="1" />
          </div>
          <div class="as-match__corner as-d-none as-d-lg-flex">
            <SkeletonLoader width="50px" height="20px" :line="1" />
          </div>
          <div class="as-match__yellow-goal as-d-none as-d-lg-flex">
            <SkeletonLoader width="50px" height="20px" :line="1" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
const commonStore = usecommonStore();

interface IProps {
}

const props = withDefaults(defineProps<IProps>(), {});

const siteName = computed(() => commonStore.getSiteName);
</script>

